export const countriesData = [
    { code: 'US', name: 'United States', dial_code: '+1', flag: '🇺🇸' },
    { code: 'CN', name: 'China', dial_code: '+86', flag: '🇨🇳' },
    { code: 'IN', name: 'India', dial_code: '+91', flag: '🇮🇳' },
    { code: 'JP', name: 'Japan', dial_code: '+81', flag: '🇯🇵' },
    { code: 'DE', name: 'Germany', dial_code: '+49', flag: '🇩🇪' },
    { code: 'GB', name: 'United Kingdom', dial_code: '+44', flag: '🇬🇧' },
    { code: 'FR', name: 'France', dial_code: '+33', flag: '🇫🇷' },
    { code: 'CA', name: 'Canada', dial_code: '+1', flag: '🇨🇦' },
    { code: 'IT', name: 'Italy', dial_code: '+39', flag: '🇮🇹' },
    { code: 'BR', name: 'Brazil', dial_code: '+55', flag: '🇧🇷' },
    { code: 'RU', name: 'Russia', dial_code: '+7', flag: '🇷🇺' },
    { code: 'KR', name: 'South Korea', dial_code: '+82', flag: '🇰🇷' },
    { code: 'AU', name: 'Australia', dial_code: '+61', flag: '🇦🇺' },
    { code: 'MX', name: 'Mexico', dial_code: '+52', flag: '🇲🇽' },
    { code: 'ID', name: 'Indonesia', dial_code: '+62', flag: '🇮🇩' },
    { code: 'NL', name: 'Netherlands', dial_code: '+31', flag: '🇳🇱' },
    { code: 'ES', name: 'Spain', dial_code: '+34', flag: '🇪🇸' },
    { code: 'CH', name: 'Switzerland', dial_code: '+41', flag: '🇨🇭' },
    { code: 'TR', name: 'Turkey', dial_code: '+90', flag: '🇹🇷' },
    { code: 'AR', name: 'Argentina', dial_code: '+54', flag: '🇦🇷' },
    { code: 'SE', name: 'Sweden', dial_code: '+46', flag: '🇸🇪' },
    { code: 'BE', name: 'Belgium', dial_code: '+32', flag: '🇧🇪' },
    { code: 'PL', name: 'Poland', dial_code: '+48', flag: '🇵🇱' },
    { code: 'AT', name: 'Austria', dial_code: '+43', flag: '🇦🇹' },
    { code: 'TH', name: 'Thailand', dial_code: '+66', flag: '🇹🇭' },
    { code: 'DK', name: 'Denmark', dial_code: '+45', flag: '🇩🇰' },
    { code: 'NO', name: 'Norway', dial_code: '+47', flag: '🇳🇴' },
    { code: 'IE', name: 'Ireland', dial_code: '+353', flag: '🇮🇪' },
    { code: 'SG', name: 'Singapore', dial_code: '+65', flag: '🇸🇬' },
    { code: 'FI', name: 'Finland', dial_code: '+358', flag: '🇫🇮' },
    { code: 'ZA', name: 'South Africa', dial_code: '+27', flag: '🇿🇦' },
  
    // Middle East Countries (Saudi Arabia already included)
    { code: 'AE', name: 'United Arab Emirates', dial_code: '+971', flag: '🇦🇪' },
    { code: 'QA', name: 'Qatar', dial_code: '+974', flag: '🇶🇦' },
    { code: 'OM', name: 'Oman', dial_code: '+968', flag: '🇴🇲' },
    { code: 'KW', name: 'Kuwait', dial_code: '+965', flag: '🇰🇼' },
    { code: 'BH', name: 'Bahrain', dial_code: '+973', flag: '🇧🇭' },
    { code: 'JO', name: 'Jordan', dial_code: '+962', flag: '🇯🇴' },
    { code: 'IL', name: 'Israel', dial_code: '+972', flag: '🇮🇱' },
    { code: 'LB', name: 'Lebanon', dial_code: '+961', flag: '🇱🇧' },
    { code: 'SY', name: 'Syria', dial_code: '+963', flag: '🇸🇾' },
    { code: 'YE', name: 'Yemen', dial_code: '+967', flag: '🇾🇪' },
    { code: 'IR', name: 'Iran', dial_code: '+98', flag: '🇮🇷' },
    { code: 'IQ', name: 'Iraq', dial_code: '+964', flag: '🇮🇶' },
    { code: 'PS', name: 'Palestine', dial_code: '+970', flag: '🇵🇸' },
  
    // India's Neighbouring Countries (China already included)
    { code: 'PK', name: 'Pakistan', dial_code: '+92', flag: '🇵🇰' },
    { code: 'NP', name: 'Nepal', dial_code: '+977', flag: '🇳🇵' },
    { code: 'BT', name: 'Bhutan', dial_code: '+975', flag: '🇧🇹' },
    { code: 'BD', name: 'Bangladesh', dial_code: '+880', flag: '🇧🇩' },
    { code: 'LK', name: 'Sri Lanka', dial_code: '+94', flag: '🇱🇰' },
    { code: 'AF', name: 'Afghanistan', dial_code: '+93', flag: '🇦🇫' },
    { code: 'MM', name: 'Myanmar', dial_code: '+95', flag: '🇲🇲' },
  
  ];
  
  export const imageBaseUrl = () => {
    const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
    return imageBaseUrl;
  };